import * as Yup from 'yup'

export const usuarioPerfilFazendaEsquema = Yup.object().shape({
    editar: Yup.boolean(),
    usuario: Yup.object().required('Campo obrigatório').nullable(),
    perfil: Yup.object().required('Campo obrigatório').nullable(),
    clientes: Yup.mixed().when('editar', {
        is: true,
        then: Yup.object().required('Campo obrigatório').nullable(),
        otherwise: Yup.array().min(1, 'Campo obrigatório').nullable(),
    }),
})
